import axios from "axios";
import Const from "../utils/constant";

const axiosInstance = axios.create({
  baseURL: `${Const.API.BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const storedUser = localStorage.getItem(Const.STORAGE_KEYS.USER);
      if (storedUser) {
        const userObj = JSON.parse(storedUser);
        const token = userObj?.token || userObj?.accessToken || (typeof userObj === "string" ? userObj : null);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (e) {
      console.error("Error retrieving auth token:", e);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
